import { Component, inject } from '@angular/core'

import { Hunt } from '@cyborg-monorepo/hunter/common'
import { DIALOG_DATA, DialogRef, DialogService } from '@hyperkit'

import { HuntTemplateService } from '../../../shared/services/hunt-template.service'
import { HuntAPIService } from '../../services/api/hunt-api.service'

@Component({
  standalone: false,
  selector: 'archive-hunt-dialog',
  templateUrl: './archive-hunt-dialog.component.html',
  styleUrls: ['./archive-hunt-dialog.component.scss'],
})
export class ArchiveHuntDialogComponent {
  dialogRef = inject<DialogRef<Hunt>>(DialogRef)
  dialogService = inject(DialogService)
  huntTemplateService = inject(HuntTemplateService)
  huntService = inject(HuntAPIService)
  hunt = inject<Hunt>(DIALOG_DATA, { optional: true })

  public onSubmit(): void {
    this.huntService.archiveHunt(this.hunt.id).subscribe((hunt) => {
      this.dialogRef.close(hunt)
    })
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
